import {
  ADD,
  API_FAILURE,
  API_PENDING,
  API_SUCCESS,
  COUNTRY,
  CREATE,
  DELETE,
  DOCTOR,
  NATIONALITY,
  READ,
  READ_SINGLE,
  UPDATE,
} from '../actions/actionTypes';

const initialState = {
  nationalities: [],
  countries: [],
  doctor: {
    address: {},
    bankAccount: {},
  },
  doctors: [],
  loading: false,
};

function doctor(state = initialState, action) {
  switch (action.type) {
    case `${DOCTOR} ${CREATE} ${API_PENDING}`:
    case `${DOCTOR} ${DELETE} ${API_PENDING}`:
    case `${DOCTOR} ${READ_SINGLE} ${API_PENDING}`:
    case `${DOCTOR} ${READ} ${API_PENDING}`:
    case `${NATIONALITY} ${READ} ${API_PENDING}`:
    case `${COUNTRY} ${READ} ${API_PENDING}`:
      return { ...state, loading: true };
    case `${DOCTOR} ${CREATE} ${API_SUCCESS}`:
    case `${DOCTOR} ${DELETE} ${API_SUCCESS}`:
    case `${DOCTOR} ${CREATE} ${API_FAILURE}`:
    case `${DOCTOR} ${DELETE} ${API_FAILURE}`:
    case `${DOCTOR} ${UPDATE} ${API_FAILURE}`:
    case `${DOCTOR} ${READ} ${API_FAILURE}`:
    case `${NATIONALITY} ${READ} ${API_FAILURE}`:
    case `${COUNTRY} ${READ} ${API_FAILURE}`:
      return { ...state, loading: false };
    case `${DOCTOR} ${ADD}`:
      return {
        ...state,
        doctor: {
          address: {},
          bankAccount: {},
        },
        loading: false,
      };
    case `${DOCTOR} ${READ} ${API_SUCCESS}`:
      return { ...state, doctors: action.payload, loading: false };
    case `${NATIONALITY} ${READ} ${API_SUCCESS}`:
      return { ...state, nationalities: action.payload, loading: false };
    case `${COUNTRY} ${READ} ${API_SUCCESS}`:
      return { ...state, countries: action.payload, loading: false };
    case `${DOCTOR} ${READ_SINGLE} ${API_FAILURE}`:
    case `${DOCTOR} ${UPDATE} ${API_SUCCESS}`:
    case `${DOCTOR} ${READ_SINGLE} ${API_SUCCESS}`:
      return {
        ...state,
        loading: false,
        doctor: action.payload,
      };
    default:
      return { ...state };
  }
}

export default doctor;
